import { ErrorRetry } from "../../common/ErrorRetry";
import { RevenueChart } from "./RevenueChart";

export function ReportSummaryTrendsSection({ state, trendsData }) {
  return state.loading ? (
    <div>
      <span className="mb-4 text-xl text-[#1A1A1A]">Revenue Trends</span>
      <div className="flex items-center justify-center py-10">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin" />
      </div>
    </div>
  ) : state.error ? (
    <div>
      <span className="mb-4 text-xl text-[#1A1A1A]">Revenue Trends</span>
      <ErrorRetry message={state.message} onRetry={state.onRetry} />
    </div>
  ) : trendsData.length > 0 ? (
    <div>
      <span className="mb-4 text-xl text-[#1A1A1A]">Revenue Trends</span>
      <RevenueChart reportSummaryData={trendsData} />
    </div>
  ) : (
    <div className="py-6 text-gray-500 text-center">
      No revenue trend data available
    </div>
  );
}
